import { useEffect, useState } from 'react';
import axios from 'axios';
import { isEmpty } from 'lodash';
import { getApiHeaders } from '../utils/header-util';
import getFormattedError from './get-formatted-error';

const defaultResponse = {
   data: [],
   isLoading: false,
   error: null,
};

export const appendApiHeaders = (apiOptions) => {
   const { method = 'GET', headers = {} } = apiOptions;
   const commonApiHeaders = getApiHeaders(headers);

   return {
      ...apiOptions,
      method,
      headers: {
         ...commonApiHeaders,
         ...headers,
      },
   };
};

const useApi = (apiDetails, responseData = defaultResponse) => {
   const [apiOptions, setApiOptions] = useState(apiDetails);
   const [response, setResponse] = useState(responseData);

   useEffect(() => {
      const fetchData = async () => {
         const { url = '', transformData = [] } = apiOptions;

         if (isEmpty(url)) {
            return;
         }

         if (!isEmpty(transformData)) {
            apiOptions.transformResponse = transformData;
         }

         setResponse({ ...responseData, isLoading: true });
         try {
            if (!apiOptions.isAbort) {
               const responseReceived = await axios(
                  appendApiHeaders(apiOptions)
               );
               const updatedResponse = isEmpty(transformData)
                  ? {
                       data: responseReceived.data,
                       error: null,
                       isLoading: false,
                    }
                  : responseReceived;
               setResponse(updatedResponse);
            } else {
               apiOptions.abortController.abort();
            }
         } catch (error) {
            setResponse({
               data: [],
               error: getFormattedError(error),
               isLoading: false,
               message: error?.response?.data?.message,
            });
         }
      };

      fetchData();
   }, [apiOptions, responseData]);

   return [response, setApiOptions];
};

export default useApi;
